import { Menu } from 'lucide-react'
import { NavLink } from 'react-router-dom'

import { Icon } from '../lib/icons'

/** Sólo los accesos que se miran más seguido — el resto de las secciones
 *  (Exchanges, Runs, Walk-forward, Datos, Estrategias) se llega desde acá
 *  vía "Más", que abre el cajón completo del sidebar en vez de duplicar
 *  toda la navegación en una barra que no entra en una pantalla chica. */
//: Mismo orden en que aparecen en el sidebar (`AppSidebar.tsx#NAV_ITEMS`):
//: Dashboard, Bots y Alertas son accesos de primer nivel ahí; Matriz vive
//: adentro del acordeón "Backtesting", que va después — por eso Matriz
//: cierra acá también, aunque en el sidebar ni siquiera es un ítem de
//: primer nivel.
const BOTTOM_NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
  { to: '/bots', label: 'Bots', icon: 'bots' },
  { to: '/alertas', label: 'Alertas', icon: 'alerts' },
  { to: '/matriz', label: 'Matriz', icon: 'matrix', end: true },
]

export function BottomNav({ onOpenMore }: { onOpenMore: () => void }) {
  return (
    <nav className="bottom-nav" aria-label="Navegación principal">
      {BOTTOM_NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) => `bottom-nav-item${isActive ? ' is-active' : ''}`}
        >
          <Icon name={item.icon} size={20} />
          <span>{item.label}</span>
        </NavLink>
      ))}
      <button type="button" className="bottom-nav-item" onClick={onOpenMore}>
        <Menu size={20} />
        <span>Más</span>
      </button>
    </nav>
  )
}
